import * as actionTypes from './actionTypes';
import * as eventTypes from './eventTypes';
import api from './api';
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from 'actions/actionCreators/httpActions';
import { showError } from 'actions/actionCreators/snackbarActions';
import { getCalculationMethodsState, getCalcMethodsFlags } from './selectors';

export function loadCommissions(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;

    let commissions = getState().currentOffer.commissions[key];
    if (commissions) {
      loading = commissions.loading;
      loaded = commissions.loaded;
    }

    if (loading || loaded) return;

    dispatch({ type: actionTypes.LOAD_COMMISSIONS_STARTED, id: key });

    try {
      commissions = await dispatch(sendHttpRequest(api.getCommissions(documentId, siteId)));
      const payload = commissions.map(x => {
        return { ...x, id: `${x.documentId}-${x.siteId}` };
      });
      dispatch({ type: actionTypes.LOAD_COMMISSIONS_SUCCESS, payload: payload, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadCalculationMethods(commissionId) {
  return async (dispatch, getState) => {
    let loading = false,
      loaded = false;

    let calculationMethods = getCalcMethodsFlags(getState().currentOffer.calculationMethods, getState().entities, commissionId);
    if (calculationMethods) {
      loading = calculationMethods.loading;
      loaded = calculationMethods.loaded;
    }
    if (!loading && loaded)
      return getCalculationMethodsState(getState().currentOffer.calculationMethods, getState().entities, commissionId);
    try {
      calculationMethods = await dispatch(sendHttpRequest(api.getCalculationMethods(commissionId)));
      dispatch({ type: actionTypes.LOAD_CALCULATION_METHODS_SUCCESS, payload: calculationMethods, id: commissionId });
      return calculationMethods;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateCommissions(documentId, siteId, commissions, isSubsidy, callback) {
  return async dispatch => {
    const key = `${documentId}-${siteId}`;
    try {
      dispatch({ type: actionTypes.SAVE_COMMISSIONS_STARTED, id: key, isSubsidy: isSubsidy });
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.updateCommissions(documentId, siteId, commissions, isSubsidy),
          'updateCommissionsCommand',
          isSubsidy ? [eventTypes.SUBSIDIES_UPDATED] : [eventTypes.COMMISSIONS_UPDATED]
        )
      );

      dispatch({ type: actionTypes.SAVE_COMMISSIONS_FINISHED, id: key });
      if (event.ok) {
        dispatch({ type: actionTypes.COMMISSIONS_UPDATED, payload: event.eventBody.commissions, id: key });
      }
      callback();
      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function computeCommission(
  initialCommission,
  commissionId,
  calculationMethod,
  documentId,
  siteId,
  commissionPercent,
  commissionAmount,
  percentChanged,
  idx,
  isSubsidy,
  callback
) {
  return async dispatch => {
    const key = `${documentId}-${siteId}`;
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.computeCommission(
            documentId,
            siteId,
            commissionPercent,
            commissionAmount,
            calculationMethod.calculationMethodId,
            percentChanged
          ),
          'computeCommissionCommand',
          [eventTypes.COMMISSION_COMPUTED],
          false
        )
      );

      if (event.ok) {
        await dispatch({
          type: actionTypes.COMMISSION_COMPUTED,
          payload: event.eventBody,
          initialCommission: initialCommission,
          calculationMethod: calculationMethod,
          commissionId: commissionId,
          key: key,
          idx: idx,
          isSubsidy: isSubsidy
        });
      }
      callback();
    } catch (error) {
      await dispatch(showError(error.message, error.correlationId));
      throw error;
    } finally {
      await dispatch({ type: actionTypes.COMPUTED_RESET, key: key });
    }
  };
}
export function addCommission(commission) {
  return async dispatch => {
    const key = `${commission.documentId}-${commission.siteId}`;
    try {
      dispatch({ type: actionTypes.COMMISSION_ADDED, commission: commission, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function deleteCommission(documentId, siteId, commission) {
  return async dispatch => {
    const key = `${documentId}-${siteId}`;
    try {
      dispatch({ type: actionTypes.COMMISSION_DELETED, commission: commission, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
